<template>
  <div id="app">
	<!-- 	 <div v-if="!network">      
					<h3>我没网了</h3>      
					<div @click="onRefresh">刷新</div>      
			</div> -->
   <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
// import { mapState } from 'vuex';
import store from '@/store/index.js';
export default {
  name: 'App',
  computed: {    
	  // ...mapState(['network'])
  },
	created() {
	  // 在页面加载时读取localStorage里的状态信息
	  if (localStorage.getItem('store')) {
		  let localStore = JSON.parse(localStorage.getItem('store'))
		  store.commit('changeIsLogin', localStore.isLogin);
		  store.commit('changeUserInfo', localStore.userInfo);
		  store.commit('changeNetwork', localStore.network);
	  }	  
	},
  methods: {
	  // 通过跳转一个空页面再返回的方式来实现刷新当前页面数据的目的
	  onRefresh () {      
		  this.$router.replace('/refresh')    
	  }  
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;  
}
.el-container{
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue